export { default } from './AccountExpiryWarning';



// WEBPACK FOOTER //
// ./app/components/borrowing/sidebar/AccountExpiryWarning/index.js